module.exports = __webpack_public_path__ + "static/media/down-red-icon.a85ebd07.png";